import { default as React, useEffect, useState } from "react";
import Loading from "../../components/loading";
import PostCardById from "../../components/post-card-by-id";
// import Layout from "../../components/layout"
import {default as SeoComponent} from "../../components/seo";
// import styled from 'styled-components'
import SharePanel from "../../components/share";
import { PostsUtils } from "../../utils/postUtils";

const CategoryArchive = (props) => {
  const {
    pageContext: {
      name,
      slug,
      // posts,
      // currentPage,
      // nextPage,
      // vertical,
      categoryIds,
    },
  } = props;

  console.log("slug", slug);

  const [sources, setSources] = useState(null);
  const [allPosts, setAllPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(-1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  function getData(direction = "next") {
    var postUtils = new PostsUtils(
      { categories: categoryIds || {} },
      sources,
      currentPage
    );

    setAllPosts([]);
    setIsLoading(true);
    var res = postUtils.getPosts(direction);
    res.then((res) => {
      setAllPosts(res.data || []);
      setSources(res.sources);
      setCurrentPage(res.currentPage);
      setHasNextPage(res.hasNextPage);
      setIsLoading(false);
    });
  }

  function getNextData() {
    getData("next");
  }
  function getPreviousData() {
    getData("previous");
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="archive newmag-single-article">
      {isLoading && (
        <div>
          <Loading />
        </div>
      )}

      <SeoComponent
        title={`Category - ${name}`}
        description={`A collection of posts from the ${name} category.`}
      />
      {/* <header className="page-header archive-page" >
        <center><PageTitleStyle style={{color: chanelColor[name.toLowerCase()], textShadow: "2.2px 0 "+chanelColor[name.toLowerCase()]}}>{name}</PageTitleStyle></center>
        <center><PageSubTitleStyle>{chanelSubtitle[name.toLowerCase()]}</PageSubTitleStyle></center>
      </header> */}
      <div
        className="newmag_salvati"
        style={{
          background: "linear-gradient(53.35deg, #EE3D49 0%, #CB356B 100%)",
          marginLeft: "-4.7%",
          height: "310px",
          width: "110%",
        }}
      >
        <div
          className="newmag_salvati_title"
          style={{
            color: "white",
            height: "135px",
            width: "557px",
            fontFamily: "aktiv-grotesk",
            fontSize: "108px",
            letterSpacing: "2.4px",
            lineHeight: "139px",
            fontWeight: "800",
            paddingLeft: "145px",
            paddingTop: "59px",
          }}
        >
          {name}
        </div>
      </div>

      <div
        style={{
          marginTop: "1rem",
          marginBottom: "1rem",
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        {allPosts &&
          allPosts
            .map((post) => ({
              // url: post.link,
              // categories: post.categories,
              // category: post.primary_category,
              // category_link: RegexUtils.clearUrlFromString(
              //   post.primary_category_link
              // ),
              // title: post.title,
              // featured_image: post?.featuredImage?.node?.mediaItemUrl,
              // author: post?.author.node.name,
              // video: post.video_content,
              // id: post.id,
              // date: post.date,
              // is_media: false, // TODO: check is_media
              id: post.id,
              site: post.site,
            }))
            .map((post) => {
              // return <PostEntry key={post.id} post={post} />
              return (
                <PostCardById
                  key={post.id + "_" + post.date}
                  id={post.id}
                  site={post.site}
                >
                  {" "}
                </PostCardById>
              );
            })}
        <SharePanel display="none" />
      </div>
      {allPosts && (
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
          }}
        >
          {currentPage !== 0 && (
            <button
              rel="post"
              key={"prev-post"}
              style={{ width: "6rem", marginRight: "1rem" }}
              onClick={getPreviousData}
            >
              <div
                style={{
                  marginRight: "1rem",
                  fontSize: "13px",
                  borderRadius: "5px",
                  textAlign: "center",
                  height: "33px",
                  textTransform: "uppercase",
                  padding: "5px 10px 8px 10px",
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  flexDirection: "column",
                }}
              >
                {"PREVIOUS"}
              </div>
            </button>
          )}

          {hasNextPage && (
            <button
              rel="post"
              key={"next-post"}
              style={{ width: "6rem" }}
              onClick={getNextData}
            >
              <div
                style={{
                  fontSize: "13px",
                  borderRadius: "5px",
                  textAlign: "center",
                  height: "33px",
                  textTransform: "uppercase",
                  padding: "5px 10px 8px 10px",
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  flexDirection: "column",
                }}
              >
                {"NEXT"}
              </div>
            </button>
          )}
        </div>
      )}
      {/* <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "5rem",
          marginBottom: "5rem",
        }}
      >
        {currentPage !== 1 && (
          <Link
            rel="category"
            key={name}
            style={{ width: "fit-content" }}
            to={`/category/${slug}/${currentPage !== 2 ? currentPage - 1 : ""}`}
          >
            <div
              style={{
                marginRight: "1rem",
                backgroundColor: "#EBF5FF",
                color: "#43BDCC",
                fontSize: "13px",
                borderRadius: "5px",
                textAlign: "center",
                height: "33px",
                textTransform: "uppercase",
                width: "fit-content",
                padding: "5px 10px 8px 10px",
              }}
            >
              {"PREVIOUS"}
            </div>
          </Link>
        )}
        {nextPage && (
          <Link
            rel="category"
            key={name}
            style={{ width: "fit-content" }}
            to={`/category/${slug}/${nextPage}`}
          >
            <div
              style={{
                backgroundColor: "#EBF5FF",
                color: "#43BDCC",
                fontSize: "13px",
                borderRadius: "5px",
                textAlign: "center",
                height: "33px",
                textTransform: "uppercase",
                width: "fit-content",
                padding: "5px 10px 8px 10px",
              }}
            >
              {"NEXT"}
            </div>
          </Link>
        )}
      </div> */}
    </div>
  );
};

export default CategoryArchive;
